var _rect, _rect2, _circle, _circle2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagOfPakistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    viewBox: "-75 -40 120 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag of Pakistan") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -75,
    y: -40,
    width: 120,
    height: 80,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -45,
    y: -40,
    width: 90,
    height: 80,
    fill: "#01411C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 24,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 22,
    cx: -7,
    cy: -40,
    fill: "#01411C",
    transform: "rotate(-41.63354, 45, -40)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0,-513674 301930,415571 -488533,-158734 488533,-158734 -301930,415571",
    fill: "#fff",
    transform: "rotate(-41.63354) translate(16) rotate(18) scale(0.00001557408)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfPakistan);
export default __webpack_public_path__ + "static/media/Flag_of_Pakistan.ffd6654c4d4fd2abef7658c4259bcb28.svg";
export { ForwardRef as ReactComponent };